import { render } from "./QuestionDialog.vue?vue&type=template&id=65425374&scoped=true"
import script from "./QuestionDialog.vue?vue&type=script&lang=js"
export * from "./QuestionDialog.vue?vue&type=script&lang=js"

import "./QuestionDialog.vue?vue&type=style&index=0&id=65425374&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65425374"]])

export default __exports__